import type { IFullArticle, TContent } from '~/types/common';
import type { ISingleArticleMeta } from '~/types/store/singleArticle';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const useSingleArticleStore = wrapPiniaStore(
  defineStore('single-article', {
    state: () => ({
      article: null as IFullArticle | null,
      fullscreenSlides: [] as string[],
      meta: null as ISingleArticleMeta | null,
    }),

    actions: {
      setArticle(article: IFullArticle) {
        this.article = article;
      },

      setMeta(meta: ISingleArticleMeta) {
        this.meta = meta;
      },

      setFullscreenSlide(slide: TContent) {
        this.fullscreenSlides.push(slide.attributes.url);
      },
    },
  }),
);
